import Vue, { getCurrentInstance } from 'vue'
import { VueConstructor } from 'vue/types/vue'

export default function useCurrentInstance(): Vue {
  const instance = getCurrentInstance()
  return instance?.proxy || (instance as unknown as InstanceType<VueConstructor>) || new Vue({})
}
